import React from 'react';
import { Dialog, DialogContent, Box, IconButton } from '@mui/material';
import AdaptiveImage from '../AdaptiveImage';
import CloseIcon from '@mui/icons-material/Close';

const FullscreenImageDialog = ({ open, onClose, imageUrl, alt }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="xl"
      fullWidth
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ position: 'relative' }}>
          <AdaptiveImage
            imageUrl={imageUrl}
            alt={alt}
            sx={{ 
              width: '100%',
              height: 'auto',
              maxHeight: '90vh',
              objectFit: 'contain'
            }}
          />
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              bgcolor: 'background.paper',
              '&:hover': {
                bgcolor: 'background.paper',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FullscreenImageDialog; 